export default __webpack_public_path__ + "static/media/beetrack.231e9e6b.png";